import { Validators, FormControl } from '@angular/forms';

export class ItensTratamentoForm {

    static getForm(){
        return { 
            alinhamentoNivelamento: [],
            avancoMandibular: '',
            expansaoSuperior: '',
            expansaoInferior: '',
            disjuncaoERM: '',
            disjuncaoERMProtracaoMandibular: '',
            verticalizacao: '',
            txtVerticalizacao: new FormControl({ value: '', disabled: true }, Validators.required),
            exodontia: '',
            txtExodontia: new FormControl({ value: '', disabled: true }, Validators.required),
            distralizacaoMolarSuperior: '',
            distralizacaoMolarInferior: '',
            extrusao: '',
            txtExtrusao: new FormControl({ value: '', disabled: true }, Validators.required),
            intrusao: '',
            txtIntrusao: new FormControl({ value: '', disabled: true }, Validators.required),
            fechamentoDiastemas: '',
            txtFechamentoDiastemas: new FormControl({ value: '', disabled: true }, Validators.required),
            desgasteInterproximal: '',
            txtDesgasteInterproximal: new FormControl({ value: '', disabled: true }, Validators.required),
            elasticoClasse2: '',
            elasticoClasse3: '',
            acertoLinhasMedianas: '',
            planejamentoOutros: '',
            txtPlanejamentoOutros: new FormControl({ value: '', disabled: true }, Validators.required),
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/util/itens-tratamento-form.ts